<template>
    <v-dialog v-model="dialog" width="800" :retain-focus="false">
        <v-card>
            <v-card-title class="headline">
                Dodaj usługę
            </v-card-title>
            <v-card-text>
                <v-form
                    ref="newForm"
                    v-model="valid"
                    lazy-validation
                    class="dimension--form mt-5 mb-5"
                >
                    <v-row>
                        <v-col cols="12" md="12" align-self="start" dense>
                            <p class="mt-2">Aktywna</p>
                            <v-switch
                                v-model="form.isActive"
                                class="mt-0 pt-0"
                                :label="form.isActive ? 'Tak' : 'Nie'"
                                :persistent-hint="true"
                            ></v-switch>
                            <p class="mt-2">Promowana</p>
                            <v-switch
                                v-model="form.promoted"
                                class="mt-0 pt-0"
                                :label="form.promoted ? 'Tak' : 'Nie'"
                                :persistent-hint="true"
                            ></v-switch>
                          <p class="mt-2">Natychmiastowa rezerwacja</p>
                          <v-switch
                              v-model="form.instant"
                              class="mt-0 pt-0"
                              :label="form.instant ? 'Tak' : 'Nie'"
                              :persistent-hint="true"
                          ></v-switch>
                            <v-autocomplete
                                v-model="form.type"
                                :items="serviceTypes"
                                item-text="name"
                                item-value="id"
                                label="Typ"
                                :rules="formRules.type"
                            ></v-autocomplete>
                            <v-select
                                v-model="form.vatRate"
                                :items="vatRates"
                                label="Stawka VAT"
                            ></v-select>
                            <v-text-field
                                v-if="form.availableWithTransport && !isCarRental"
                                v-model="form.priceWithTransport"
                                class="pt-0"
                                type="number"
                                label="Cena netto"
                                placeholder=" "
                            ></v-text-field>
                            <div v-if="isCarRental">
                              <v-text-field v-model="form.name" label="Nazwa samochodu"></v-text-field>
                              <p class="mt-2">Ceny</p>
                              <p class="mt-2">Ceny <v-icon size="24" right @click="addPrice">
                                mdi-plus
                              </v-icon></p>
                              <div v-for="(carRentalPrice, key) in carRentalPrices" :key="carRentalPrice">
                                <p class="font-weight-bold">Cena {{key + 1}} <v-icon size="24" right @click="removePrice(key)">
                                  mdi-minus
                                </v-icon></p>
                                <v-row>
                                  <v-col>
                                    <v-select v-model="carRentalPrice.dayFrom" label="Od dnia" :rules="formRules.required" :items="getDays()"
                                              item-text="value"
                                              item-value="key"></v-select>
                                  </v-col>
                                  <v-col>
                                    <v-select v-model="carRentalPrice.monthFrom" label="Od miesiąca" :rules="formRules.required" :items="getMonths()"
                                              item-text="value"
                                              item-value="key"></v-select>
                                  </v-col>
                                  <v-col>
                                    <v-select v-model="carRentalPrice.dayTo" label="Do dnia" :rules="formRules.required" :items="getDays()"
                                              item-text="value"
                                              item-value="key"></v-select>
                                  </v-col>
                                  <v-col>
                                    <v-select v-model="carRentalPrice.monthTo" label="Do miesiąca" :rules="formRules.required" :items="getMonths()"
                                              item-text="value"
                                              item-value="key">></v-select>
                                  </v-col>
                                </v-row>
                                <v-row>
                                  <v-col>
                                    <v-textarea
                                        v-model="carRentalPrice.prices"
                                        class="pt-0"
                                        label="Ceny"
                                        placeholder="liczba dni,cena"
                                        :rules="formRules.required"></v-textarea>
                                  </v-col>
                                  <v-col>
                                    <v-textarea
                                        v-model="carRentalPrice.weekendPrices"
                                        class="pt-0"
                                        label="Ceny weekendowe"
                                        placeholder="liczba dni,cena"></v-textarea>
                                  </v-col>
                                </v-row>
                              </div>
                              <v-select
                                  :items="getLocationTypes()"
                                  :rules="formRules.locationType"
                                  v-model="form.location"
                                  label="Lokalizacja odbioru"
                                  item-value="key"
                                  item-text="value"
                                  solo
                                  class="wastemaster-input-elevation"
                              ></v-select>
                              <v-textarea v-model="form.additionalLocation" label="Dokładna lokalizacja odiboru"></v-textarea>
                              <v-textarea v-model="form.fuelPolicy" label="Polityka paliwowa"></v-textarea>
                              <v-text-field v-model="form.kilometerLimit" label="Limit kilometrów"></v-text-field>
                              <v-textarea v-model="form.additionalInformation" label="Dodatkowe informacje"></v-textarea>
                              <v-select
                                  :items="getTransmissionTypes()"
                                  :rules="formRules.transmissionType"
                                  v-model="form.transmission"
                                  label="Skrzynia biegów"
                                  item-value="key"
                                  item-text="value"
                                  solo
                                  class="wastemaster-input-elevation"
                              ></v-select>
                              <v-select
                                  :items="getNumberOfSeats()"
                                  :rules="formRules.numberOfSeats"
                                  v-model="form.numberOfSeats"
                                  label="Liczba miejsc"
                                  item-value="key"
                                  item-text="value"
                                  solo
                                  class="wastemaster-input-elevation"
                              ></v-select>
                              <v-select
                                  :items="getNumberOfDoors()"
                                  :rules="formRules.numberOfDoors"
                                  v-model="form.numberOfDoors"
                                  label="Liczba drzwi"
                                  item-value="key"
                                  item-text="value"
                                  solo
                                  class="wastemaster-input-elevation"
                              ></v-select>
                              <v-select
                                  :items="getFuelTypes()"
                                  :rules="formRules.fuelType"
                                  v-model="form.fuel"
                                  label="Paliwo"
                                  item-value="key"
                                  item-text="value"
                                  solo
                                  class="wastemaster-input-elevation"
                              ></v-select>
                              <v-checkbox
                                  v-model="form.airConditioning"
                                  class="pt-0"
                                  label="Klimatyzacja"
                              ></v-checkbox>
<!--                              ->setPrices($requestDto->prices);-->
                            </div>
                            <p class="mt-2">Opis</p>
                            <ckeditor
                                v-if="form.availableWithTransport"
                                v-model="form.availableWithTransportDescription"
                                class="pt-0"
                                hint="Opis"
                                placeholder="Opis"
                                :editor="editor"
                                :config="editorConfig"
                            ></ckeditor>
                            <p class="mt-2">Szczegóły usługi po zamówieniu</p>
                            <ckeditor
                                v-if="form.availableWithTransport"
                                v-model="form.availableWithTransportSummary"
                                class="pt-0"
                                hint="Szczegóły usługi po zamówieniu"
                                placeholder="Szczegóły usługi po zamówieniu"
                                :editor="editor"
                                :config="editorConfig"
                            ></ckeditor>
                            <vue-dropzone id="dropzone" :options="dropzoneOptions"
                                          v-on:vdropzone-success="storeImageId" v-on:vdropzone-removed-file="removeImage"></vue-dropzone>
                        </v-col>
                      <v-col>
                        <v-select
                            :items="branches"
                            :rules="formRules.branches"
                            v-model="form.branches"
                            label="oddziały"
                            item-value="id"
                            item-text="name"
                            multiple
                            class="wastemaster-input-elevation"
                        ></v-select>
                      </v-col>
                    </v-row>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            @click.prevent="onSubmit"
                            type="Submit"
                            class="action-btn--green-gradient place-btn wastemaster-action-btn text-none"
                            large
                        >Dodaj&nbsp;<v-icon size="24">mdi-send</v-icon>
                        </v-btn
                        >
                    </v-card-actions>
                </v-form>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>

import api from "@/services/api";
import transactionTypeMixin from "@/mixins/transactionTypeMixin";
import transportConditionMixin from "@/mixins/transportConditionMixin";
import categoryMixin from "@/mixins/categoryMixin";
import priceMixin from "@/mixins/priceMixin";
import paymentConditionMixin from "@/mixins/paymentConditionMixin";
import dateMixin from "@/mixins/dateMixin";
import validationHelpers from '@/mixins/validationHelpers'
import vue2Dropzone from "vue2-dropzone";
import {Auth} from "../services/Auth";
import CKEditor from "@ckeditor/ckeditor5-vue2";
import ClassicEditor from '../utils/ckeditor5/build/ckeditor';
import units from "@/mixins/unitMixin";
import locationTypeMixin from "@/mixins/locationTypeMixin";
import transmissionTypeMixin from "@/mixins/transmissionTypeMixin";
import fuelTypeMixin from "@/mixins/fuelTypeMixin";

export default {
    name: 'ModalAddServiceToCompany',
    components: {
        vueDropzone: vue2Dropzone,
        ckeditor: CKEditor.component,
    },
    props: {
        branches: {
          type: Array,
          required: false,
        }
    },
    mixins: [
        locationTypeMixin,
        transmissionTypeMixin,
        fuelTypeMixin,
        transactionTypeMixin,
        transportConditionMixin,
        categoryMixin,
        priceMixin,
        paymentConditionMixin,
        dateMixin,
        validationHelpers,
        units
    ],
    created() {
        this.loadPartners();
    },
    data() {
        return {
            partners: null,
            unit: "",
            dialog: false,
            carRentalPrices: [],
            item: null,
            form: {
                partner: null,
                type: '',
                buyType: 'wastePurchase',
                wmRole: null,
                wmPrice: null,
                whoPayForWm: null,
                whoTransport: null,
                unit: 'PIECE',
                availableWithTransport: true,
                availableWithTransportDescription: '',
                availableWithTransportSummary: '',
                branches: null,
                priceWithTransport: '',
                availableWithoutTransport: false,
                availableWithoutTransportDescription: '',
                availableWithoutTransportSummary: '',
                priceWithoutTransport: '',
                photosIds: [],
                isSale: true,
                vatRate: null,
                minimumQuantity: null,
                maximumQuantity: null,
                isActive: true,
                promoted: false,
                instant: false,
                location: null,
                additionalLocation: null,
                fuelPolicy: null,
                kilometerLimit: null,
                additionalInformation: null,
                transmission: null,
                numberOfSeats: null,
                numberOfDoors: null,
                fuel: null,
                airConditioning: false,
                prices: [],
                name: null,
            },
            formRules: {
                type: [(value) => !!value || 'wybierz typ'],
                unit: [(value) => !!value || 'wybierz jednostkę'],
                locationType: [(value) => (this.isCarRental && !!value) || 'wybierz lokalizację'],
                transmissionType: [(value) => (this.isCarRental && !!value) || 'wybierz skrzynię biegów'],
                numberOfSeats: [(value) => (this.isCarRental && !!value) || 'wybierz liczbę miejsc'],
                branches: [(value) => !!value || 'wybierz oddział'],
                numberOfDoors: [(value) => (this.isCarRental && !!value) || 'wybierz liczbę drzwi'],
                fuelType: [(value) => (this.isCarRental && !!value) || 'wybierz paliwo'],
                name: [(value) => (this.isCarRental && !!value) || 'wpisz nazwe'],
            },

          wmRoles: [
            {value: 'mediation', text: 'Pośrednictwo'},
            {value: 'sell', text: 'Sprzedaż'},
          ],
          feePayer: [
            {value: 'client', text: 'Klient'},
            {value: 'partner', text: 'Partner'},
          ],
            valid: false,
            serviceTypes: [],
            serviceBuyTypes: [
                {value: 'paidUtilization', text: 'Płatna utylizacja'},
                {value: 'wastePurchase', text: 'Kupno odpadu'},
            ],
            whoTransport: [
              {value: null, text: 'Wybierz'},
              {value: 'client', text: 'Klient'},
              {value: 'seller', text: 'Sprzedawca'},
              {value: 'wm', text: 'Wastemaster'},
            ],
            vatRates: [0, 5, 8, 23],
            dropzoneOptions: {
                url: `${process.env.VUE_APP_API_URL}/api/price-list/company-branch/${this.item}/service/images`,
                thumbnailWidth: 150,
                maxFilesize: 1024 * 20,
                maxFiles: 1,
                acceptedFiles: 'image/*',
                addRemoveLinks: true,
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem(Auth.TOKEN_KEY)}`
                }
            },
            editor: ClassicEditor,
            editorConfig: {
                id: this.item,
                htmlSupport: {
                    allow: [
                        {
                            name: /.*/,
                            attributes: true,
                            classes: true,
                            styles: true
                        }
                    ],
                }
            }
        }
    },
    computed: {
      isCarRental() {
        return this.form.type && this.serviceTypes.find(type => type.id === this.form.type).isCarRental;
      },
    },
    methods: {
      getMonths() {
        let months = [];
        for (let i = 1; i <= 12; i++) {
          months.push({value: i, key: i});
        }

        return months;
      },
      getDays() {
        let days = [];
        for (let i = 1; i <= 31; i++) {
          days.push({value: i, key: i});
        }

        return days;
      },
        getNumberOfSeats() {
            let numberOfSeats = [];

            for (let i = 1; i <= 9; i++) {
                numberOfSeats.push({value: i, key: i});
            }

            return numberOfSeats;
        },
        getNumberOfDoors() {
            let numberOfDoors = [];

            for (let i = 3; i <= 5; i++) {
              numberOfDoors.push({value: i, key: i});
            }

            return numberOfDoors;
        },
        open() {
            this.dialog = true
            this.item = this.branches.length > 0 ? this.branches[0].id : '0';
            this.dropzoneOptions.url = `${process.env.VUE_APP_API_URL}/api/price-list/company-branch/${this.item}/service/images`
            this.getServiceTypes();
        },
        async onSubmit() {
            if (!this.$refs.newForm.validate()) {
                return
            }

          let servicePrices = [];

          this.carRentalPrices.forEach((price) => {
            let prices = {};
            let weekendPrices = {};

            price.prices.split('\n').forEach((line) => {
              let [days, price] = line.split(',');
              if (days && price) {
                prices[days] = price;
              }
            });
            price.weekendPrices.split('\n').forEach((line) => {
              let [days, price] = line.split(',');
              if (days && price) {
                weekendPrices[days] = price;
              }
            });

            if (weekendPrices === {}) {
              weekendPrices = null;
            }

            price.prices = prices;
            price.weekendPrices = weekendPrices;

            servicePrices.push(price);
          });

            const service = {
                partner: this.form.partner,
                type: this.form.type,
                buyType: this.form.buyType,
                wmRole: this.form.wmRole,
                wmPrice: this.form.wmPrice,
                whoPayForWm: this.form.whoPayForWm,
                whoTransport: this.form.whoTransport,
                availableWithTransport: this.form.availableWithTransport ?? false,
                availableWithTransportDescription: this.form.availableWithTransportDescription,
                availableWithTransportSummary: this.form.availableWithTransportSummary,
                priceWithTransport: this.form.priceWithTransport ? parseFloat(this.form.priceWithTransport) : null,
                availableWithoutTransport: this.form.availableWithoutTransport ?? false,
                availableWithoutTransportDescription: this.form.availableWithoutTransportDescription,
                availableWithoutTransportSummary: this.form.availableWithoutTransportSummary,
                priceWithoutTransport: this.form.priceWithoutTransport ? parseFloat(this.form.priceWithoutTransport) : null,
                unit: this.form.unit,
                branches: this.form.branches,
                photosIds: this.form.photosIds,
                isSale: this.form.isSale,
                isActive: this.form.isActive,
                promoted: this.form.promoted,
                instant: this.form.instant,
                vatRate: this.form.vatRate,
                minimumQuantity: this.form.minimumQuantity !== '' ? this.form.minimumQuantity : null,
                maximumQuantity: this.form.maximumQuantity !== '' ? this.form.maximumQuantity : null,
                location: this.form.location,
                additionalLocation: this.form.additionalLocation,
                fuelPolicy: this.form.fuelPolicy,
                kilometerLimit: this.form.kilometerLimit,
                additionalInformation: this.form.additionalInformation,
                transmission: this.form.transmission,
                numberOfSeats: this.form.numberOfSeats,
                numberOfDoors: this.form.numberOfDoors,
                fuel: this.form.fuel,
                airConditioning: this.form.airConditioning,
                prices: servicePrices,
                name: this.form.name
            }
            api
                .post('/api/price-list/company/service', service)
                .then(() => {
                    this.$root.$emit('notifySuccess', {
                        html: 'Usługa została dodana.',
                    });
                    this.dialog = false;
                    this.form.type = '';
                    this.form.buyType = '';
                    this.form.wmRole = null;
                    this.form.whoTransport = null;
                    this.form.availableWithTransport = true;
                    this.form.availableWithTransportDescription = '';
                    this.form.availableWithTransportSummary = '';
                    this.form.priceWithTransport = '';
                    this.form.availableWithoutTransport = false;
                    this.form.availableWithoutTransportDescription = '';
                    this.form.availableWithoutTransportSummary = '';
                    this.form.priceWithoutTransport = '';
                    this.form.photosIds = [];
                    this.form.branches = [];
                    this.form.isSale = true;
                    this.form.promoted = false;
                    this.form.instant = false;
                    this.form.minimumQuantity = '';
                    this.form.maximumQuantity = '';
                    this.$parent.load();
                })
                .catch((error) => {
                    console.error('Error when adding a dimension:', error);
                    this.$root.$emit('notifyError', {
                        html: 'Wystąpił błąd.',
                    });
                })
        },
        getServiceTypes() {
            api
                .get('/api/price-list/company-branch/' + this.item + '/service/type')
                .then((response) => {
                    this.serviceTypes = [];

                    response.data.forEach(service => {
                        service.name = service.name + ' - ' + service.category;
                        this.serviceTypes.push(service);
                    });
                })
                .catch((error) => {
                    console.error('Error when getting a service types:', error);
                    this.$root.$emit('notifyError', {
                        html: 'Wystąpił błąd.',
                    });
                })
        },
        storeImageId(event, image) {
            this.form.photosIds.push(image.id);
        },
        removeImage() {
            this.form.photosIds = [];
        },
        async loadPartners() {
            api
                .get('/api/companies?partner=true')
                .then((data) => {
                    this.partners = data.data.items;
                })
                .catch((error) => {
                    console.error('Error when loading partners: ', error);
                })
        },
      addPrice() {
        this.carRentalPrices.push({
          monthFrom: null,
          monthTo: null,
          dayFrom: null,
          dayTo: null,
          prices: '',
          weekendPrices: ''
        });
      },
      removePrice(index) {
        this.carRentalPrices.splice(index, 1);
      },
    },
}
</script>

<style scoped></style>
